const WISHLIST_STORAGE_KEY = 'ink-crypt-wishlist';
const WISHLIST_UPDATED_EVENT = 'wishlist:updated';

function getWishlist() {
  try {
    const raw = localStorage.getItem(WISHLIST_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function setWishlist(handles) {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(handles));
  window.dispatchEvent(new CustomEvent(WISHLIST_UPDATED_EVENT, { detail: { handles } }));
}

function isInWishlist(handle) {
  return getWishlist().includes(handle);
}

function toggleWishlist(handle) {
  const list = getWishlist();
  const index = list.indexOf(handle);
  if (index > -1) {
    list.splice(index, 1);
  } else {
    list.push(handle);
  }
  setWishlist(list);
  return list.includes(handle);
}

class WishlistButtonComponent extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.productHandle;
    this.button = this.querySelector('[ref="wishlistToggle"]');
    if (!this.button || !this.handle) return;

    this.updateState();

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(this.handle);
      this.updateState();
    });

    window.addEventListener(WISHLIST_UPDATED_EVENT, () => this.updateState());
  }

  updateState() {
    const active = isInWishlist(this.handle);
    this.classList.toggle('is-active', active);
    this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
    this.button.setAttribute(
      'aria-label',
      active ? this.dataset.labelRemove : this.dataset.labelAdd
    );
  }
}

class WishlistCountComponent extends HTMLElement {
  connectedCallback() {
    this.update();
    window.addEventListener(WISHLIST_UPDATED_EVENT, () => this.update());
  }

  update() {
    const count = getWishlist().length;
    this.textContent = count;
    this.hidden = count === 0;
  }
}

class WishlistPageComponent extends HTMLElement {
  async connectedCallback() {
    this.render();
    window.addEventListener(WISHLIST_UPDATED_EVENT, () => this.render());
  }

  async render() {
    const handles = getWishlist();
    const emptyState = this.querySelector('[ref="emptyState"]');
    const grid = this.querySelector('[ref="grid"]');
    if (!grid) return;

    if (handles.length === 0) {
      grid.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;

    const products = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((res) => (res.ok ? res.json() : null))
          .catch(() => null)
      )
    );

    grid.innerHTML = products
      .filter(Boolean)
      .map((product) => {
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const price = (product.price / 100).toFixed(2);
        return `
          <div class="wishlist-grid__item">
            <a href="/products/${product.handle}" class="wishlist-grid__link">
              ${image ? `<img src="${image}" alt="${product.title}" loading="lazy" width="300" height="300">` : ''}
              <span class="wishlist-grid__title">${product.title}</span>
              <span class="wishlist-grid__price">$${price}</span>
            </a>
            <button type="button" class="wishlist-grid__remove" data-handle="${product.handle}">
              Remove
            </button>
          </div>
        `;
      })
      .join('');

    grid.querySelectorAll('.wishlist-grid__remove').forEach((btn) => {
      btn.addEventListener('click', () => {
        toggleWishlist(btn.dataset.handle);
      });
    });
  }
}

customElements.define('wishlist-button-component', WishlistButtonComponent);
customElements.define('wishlist-count-component', WishlistCountComponent);
customElements.define('wishlist-page-component', WishlistPageComponent);
